import { inject, Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { GroupApiCallService } from '../group-api-call.service';
import { DetailAttribute } from '../../../../shared/models/shared.model';

@Injectable({ providedIn: 'root' })
export class ContentGroupService {
    private groupApiCallService = inject(GroupApiCallService);

    private contentGroupAttributes: DetailAttribute[] = [
        {
            label: 'Sports',
            name: 'sports',
            apiName: 'sportIds',
            type: 'list',
            placeholder: 'Select a tenant first',
            control: [Validators.required],
            dependency: 'tenantId',
        },
        {
            label: 'Regions',
            name: 'regions',
            apiName: 'regionIds',
            type: 'list',
            placeholder: 'Select a sport first',
            control: [Validators.required],
            dependency: 'sportIds',
        },
        {
            label: 'Tournaments',
            name: 'tournaments',
            apiName: 'tournamentIds',
            type: 'list',
            placeholder: 'Select a region first',
            control: [Validators.required],
            dependency: 'regionIds',
        },
    ];

    loadGroupAttributes(): DetailAttribute[] {
        return this.contentGroupAttributes;
    }

    loadContentGroupList(name: string, dependencyId: number): Observable<any> {
        let requirement: { name: string; parentId: number } | undefined;
        switch (name) {
            case 'sports':
                requirement = {
                    name: 'tenants',
                    parentId: dependencyId,
                };
                break;
            case 'regions':
                requirement = {
                    name: 'sports',
                    parentId: dependencyId,
                };
                break;
            case 'tournaments':
                requirement = {
                    name: 'regions',
                    parentId: dependencyId,
                };
                break;
        }
        return this.groupApiCallService.getContentData(name, requirement);
    }
}
